/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Ben_Eyes_EbInputs */

const en_funnel_ob_ben_eyes_eb = /** @type {(inputs: Funnel_Ob_Ben_Eyes_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You want to rest your eyes`)
};

const es_funnel_ob_ben_eyes_eb = /** @type {(inputs: Funnel_Ob_Ben_Eyes_EbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quieres descansar la vista`)
};

/**
* | output |
* | --- |
* | "You want to rest your eyes" |
*
* @param {Funnel_Ob_Ben_Eyes_EbInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_ben_eyes_eb = /** @type {((inputs?: Funnel_Ob_Ben_Eyes_EbInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Ben_Eyes_EbInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_ben_eyes_eb(inputs)
	return en_funnel_ob_ben_eyes_eb(inputs)
});